// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"social-media-sidebar-section_wrapper__WYuws"};